import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../ui';

const INITIAL_FAVORITES = [
  { id: 'fav-001', name: 'COVID Hospitalization Report', url: '/quality?filter=covid' },
  { id: 'fav-002', name: 'Flu Vaccination Tracker', url: '/quality?filter=flu' },
  { id: 'fav-003', name: 'Q1 Staffing Summary', url: '/staffing?period=q1' }
];

function FavoritesPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [favorites, setFavorites] = useState(INITIAL_FAVORITES);
  const [showModal, setShowModal] = useState(false);
  const [reportUrl, setReportUrl] = useState(location.pathname + (location.search || ''));
  const [bookmarkName, setBookmarkName] = useState('');
  const [nameError, setNameError] = useState('');

  const handleOpenModal = () => {
    setReportUrl(location.pathname + (location.search || ''));
    setBookmarkName('');
    setNameError('');
    setShowModal(true);
  };

  const handleSave = () => {
    const name = bookmarkName.trim();
    if (!name) {
      setNameError('Bookmark name is required');
      return;
    }
    setFavorites(prev => [
      ...prev,
      { id: `fav-${Date.now()}`, name, url: reportUrl.trim() || '/' }
    ]);
    setShowModal(false);
  };

  const handleDelete = (id) => {
    setFavorites(prev => prev.filter(f => f.id !== id));
  };

  const handleOpen = (url) => {
    navigate(url || '/');
  };

  return (
    <div className="dashboard-container">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Favorites</h1>
          <Button
            variant="default"
            onClick={handleOpenModal}
          >
            Add Favorite
          </Button>
        </div>

        <div className="space-y-4">
          {favorites.length === 0 ? (
            <p className="text-gray-600 py-8 text-center">No favorites yet. Click &quot;Add Favorite&quot; to save a report link.</p>
          ) : (
            favorites.map((fav) => (
              <div
                key={fav.id}
                className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50"
              >
                <div className="flex-1 min-w-0 mr-4">
                  <div className="font-bold text-gray-900 truncate">{fav.name}</div>
                  <div className="text-sm text-gray-500 truncate">{fav.url}</div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <Button
                    variant="default"
                    size="sm"
                    onClick={() => handleOpen(fav.url)}
                  >
                    Open
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleDelete(fav.id)}
                    title="Delete"
                    type="button"
                    className="p-2 text-gray-400 hover:text-red-600"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Add Favorite</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Report URL</label>
                <input
                  type="text"
                  value={reportUrl}
                  onChange={(e) => setReportUrl(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="/quality?filter=covid"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Bookmark Name</label>
                <input
                  type="text"
                  value={bookmarkName}
                  onChange={(e) => { setBookmarkName(e.target.value); setNameError(''); }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. COVID Hospitalization Report"
                />
                {nameError && <p className="text-red-600 text-sm mt-1">{nameError}</p>}
              </div>
            </div>
            <div className="flex gap-3 mt-6">
              <Button
                variant="default"
                onClick={handleSave}
              >
                Save
              </Button>
              <Button
                variant="outline"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FavoritesPage;
